import { useRef, useState, useEffect, useImperativeHandle, forwardRef } from 'react'
import { isKeycloakEnabled, isKeycloakAuthenticated, getKeycloakToken } from './keycloak'
import LoadingScreen from '@/LoadingScreen'
import AuthContext from './AuthContext'
import appConfig from '@/configs/app.config'
import { fallbackMenuPath } from '@/utils/menuFallbackPath'
import { useSessionUser, useToken } from '@/store/authStore'
import {
    apiSignIn,
    apiSignInotp,
    apiSignIn1,
    apiSignOut,
    apiSignUp,
    apiSignotp,
    apiempcodevaild,
    apichangepassword,
} from '@/services/AuthService'
import {
    REDIRECT_URL_KEY,
    CONSENT_REQUIRED_KEY,
    CONSENT_ACCEPTED_COUNT_KEY,
    CONSENT_TOTAL_KEY,
} from '@/constants/app.constant'
import { useNavigate } from 'react-router-dom'

import type {
    SignInCredential,
    SignUpCredential,
    SignotpCredential,
    SignInQrcodeCredential,
    AuthResult,
    OauthSignInCallbackPayload,
    empcodevaild,
    User,
    Token,
    SignInotpCredential,
        changepasswordsumbit
} from '@/@types/auth'
import type { ReactNode } from 'react'
import type { NavigateFunction } from 'react-router-dom'
import { useReducedMotion } from 'framer-motion'


import { messaging } from "@/firebase/firebaseConfig";
import { getToken } from "firebase/messaging";
import axios from "axios";
type AuthProviderProps = { children: ReactNode }

export type IsolatedNavigatorRef = {
    navigate: NavigateFunction
}

const IsolatedNavigator = forwardRef<IsolatedNavigatorRef>((_, ref) => {
    const navigate = useNavigate()

    useImperativeHandle(ref, () => {
        return {
            navigate,
        }
    }, [navigate])

    return <></>
})




 
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};
 
const API_URL = import.meta.env.VITE_API_URL;
// const VAPID_KEY = import.meta.env.VITE_FIREBASE_VAPID_KEY;
 
// 🔥 Initialize Firebase

 
// 🔐 Safe messaging getter

// 🚀 AUTO FCM REGISTER FUNCTION (CALL THIS AFTER LOGIN)




function AuthProvider({ children }: AuthProviderProps) {
    const signedIn = useSessionUser((state) => state.session.signedIn)
    const user = useSessionUser((state) => state.user)
    const setUser = useSessionUser((state) => state.setUser)
    const setSessionSignedIn = useSessionUser(
        (state) => state.setSessionSignedIn,
    )
    const { token, setToken } = useToken()

    const authenticated = Boolean(token && signedIn)

    // True for the brief window after a fresh Keycloak login redirect where
    // Keycloak already has a session but the existing HRMS session hasn't
    // been bootstrapped yet (signInWithKeycloak() below is still in flight).
    // Without this, <Views>/<AllRoutes> would mount immediately with
    // authenticated=false and briefly render the old /home login page
    // before the bootstrap call resolves. Computed synchronously (not just
    // set inside the effect) so that first render already reflects it --
    // otherwise the flash happens on the very first frame regardless.
    const [bootstrappingKeycloakSession, setBootstrappingKeycloakSession] =
        useState(() => isKeycloakEnabled() && !authenticated && isKeycloakAuthenticated())

    const navigatorRef = useRef<IsolatedNavigatorRef>(null)
    const username = localStorage.getItem('username')
    const empCode = localStorage.getItem('empCode')

    // Mandatory consents (privacy policy, terms & conditions, etc.) the employee
    // has not yet accepted the current version of. When present, the employee
    // must be routed to the consent screen before anywhere else -- including
    // the home page and the change-password/OTP first-login screen.
    const redirectToConsentIfPending = (pendingConsents: unknown): boolean => {
        if (!Array.isArray(pendingConsents) || pendingConsents.length === 0) {
            sessionStorage.removeItem(CONSENT_REQUIRED_KEY)
            return false
        }

        sessionStorage.setItem(CONSENT_REQUIRED_KEY, '1')
        navigatorRef.current?.navigate('/consent')
        return true
    }

   const redirect = async () => {
        const search = window.location.search
        const params = new URLSearchParams(search)
        const redirectUrl = params.get(REDIRECT_URL_KEY)


        console.log(redirectUrl); 
        


        const username = localStorage.getItem('username')
        const empCode = localStorage.getItem('empCode')
        const logincount = localStorage.getItem('logincount')

        if (username && empCode) {
            if (logincount === 'null' ) {
                console.log('ff')

                navigatorRef.current?.navigate(
                    redirectUrl
                        ? redirectUrl
                        : appConfig.authenticatedEntryPath2,
                )
            } else {
                console.log('fssf')

  



                navigatorRef.current?.navigate(
                    redirectUrl
                        ? redirectUrl
                        : appConfig.authenticatedEntryPath,
                )
//location.reload()

     
            }
        } else {
            console.log('fssfsss')
            navigatorRef.current?.navigate(
                redirectUrl ? redirectUrl : appConfig.authenticatedEntryPath1,
            )
        }
    }

    const handleSignIn = (tokens: Token, user?: User) => {
        setToken(tokens.accessToken)
        setSessionSignedIn(true)

        if (user) {
            setUser(user)
        }
    }

    const handleSignOut = () => {
        setToken('')
        setUser({})
        setSessionSignedIn(false)
        localStorage.removeItem('empCode')
        localStorage.removeItem('username')
        localStorage.clear() // Clears ALL localStorage data
        sessionStorage.removeItem(CONSENT_REQUIRED_KEY)
        sessionStorage.removeItem(CONSENT_ACCEPTED_COUNT_KEY)
        sessionStorage.removeItem(CONSENT_TOTAL_KEY)
        // sessionStorage.clear(); // Clears ALL sessionStorage data\
    }

    const signIn = async (values: SignInCredential): AuthResult => {
        try {
            const API_URL = import.meta.env.VITE_API_URL
            // Perform the dynamic API call using fetch
            
                const payload = {
  ...values,
  deviceType: "WEB", // always attach here
   serviceCode:"HRMS"
}

            
            const response = await fetch(`${API_URL}/login/validateuser`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
                mode: 'cors',
            })

            // Parse the JSON result from the response
            const result = await response.json()

            // Check for success based on your API's internal statusCode
            if (result.statusCode !== 0) {
                // Throw error with the provided message from the API
                throw new Error(result.errorDescription || 'Login failed')
            }

            localStorage.clear() // Clears ALL localStorage data

            localStorage.setItem(
                'empCode',
                result.responseContent.empCode ?? '',
            )
            localStorage.setItem(
                'username',
                result.responseContent.username ?? '',
            )
            // Masked email for display only (profile dropdown). Falls back to the
            // full username if the backend didn't send a masked value.
            localStorage.setItem(
                'maskedUsername',
                result.responseContent.maskedEmailId ??
                    result.responseContent.username ??
                    '',
            )
            localStorage.setItem('token', result.responseContent.token ?? '')
            //  localStorage.setItem('firstName', result.responseContent.firstName ?? '' result.responseContent.lastName);
            localStorage.setItem(
                'employeePhotoRefNumber',
                result.responseContent.employeePhotoRefNumber ?? '',
            )

            localStorage.setItem(
                'firstName',
                `${result.responseContent.firstName ?? ''} ${result.responseContent.lastName ?? ''}`.trim(),
            )

            let userMenuList = result.responseContent.userMenuList

            localStorage.setItem('userMenuList', JSON.stringify(userMenuList))


            let userInnerMenuList = result.responseContent.userInnerMenuList;

// Save to localStorage
localStorage.setItem('userInnerMenuList', JSON.stringify(userInnerMenuList));

            localStorage.setItem(
                'mobileNumber',
                result.responseContent.mobileNumber ?? '',
            )
            localStorage.setItem(
                'department',
                result.responseContent.departmentMasterDTO?.code ?? '',
            )
            localStorage.setItem(
                'project',
                result.responseContent.projectMasterDTO?.code ?? '',
            )
            localStorage.setItem(
                'designation',
                result.responseContent.designationMasterDTO?.code ?? '',
            )
            localStorage.setItem(
                'reportingToEmailId',
                result.responseContent.reportingToEmailId ?? '',
            )
            localStorage.setItem(
                'unmaskedReportingToEmailId',
                result.responseContent.unmaskedReportingToEmailId ?? '',
            )
            localStorage.setItem(
                'designationname',
                result.responseContent.designationMasterDTO?.name ?? '',
            )
            localStorage.setItem(
                'projectname',
                result.responseContent.projectMasterDTO?.name ?? '',
            )
            localStorage.setItem(
                'gendername',
                result.responseContent.genderMasterDTO?.name ?? '',
            )
            localStorage.setItem(
                'gendercode',
                result.responseContent.genderMasterDTO?.code ?? '',
            )
            const lastLogin = result.responseContent.loginCount
            const logincount = localStorage.getItem('logincount')
            // Assign '1' if lastLogin is null, undefined, or an empty string
            localStorage.setItem('logincount', lastLogin)
            sessionStorage.setItem('logincount', lastLogin) 
                 const userData = result.responseContent



                    

                 //   console.log(registerFCMAfterLogin(userData.empCode))


            if (logincount === 'null' ) {
            } else {
              ///  Handle sign-in logic if the API call was successful
                handleSignIn(
                    { accessToken: result.responseContent.token },
                    result.responseContent,
                )
            }
         
       //   

          //navigatorRef.current?.navigate(appConfig.authenticatedEntryPath)


            // 🔥 Calculate first accessible URL dynamically
        const allUrlPaths: string[] = userMenuList.flatMap((main: any) => {
            const urls: string[] = [];

            if (main.urlPath) {
                urls.push(main.urlPath);
            }

            if (Array.isArray(main.menuList)) {
                main.menuList.forEach((sub: any) => {
                    if (sub.urlPath) {
                        urls.push(sub.urlPath);
                    }
                });
            }

            return urls;
        });

        const firstPath =
            allUrlPaths[0] || fallbackMenuPath(userMenuList) || '/home';
const logincount1 = localStorage.getItem('logincount')
        // 🔥 Handle OTP first login
        if (logincount1 === 'null') {
            redirect();
            location.reload();
        } else if (redirectToConsentIfPending(userData.pendingConsents)) {
            // Mandatory consent(s) outstanding -- routed to /consent instead.
        } else {
            navigatorRef.current?.navigate(firstPath);

             if (userData.empCode) {
            await registerFCMAfterLogin(userData.empCode);
        }

        }

        // 🔥 Register FCM after login
       
       // console.log(userempCode); 

            return {
                status: 'success',
                message: result.message || '',
            }
        } catch (error: any) {
            return {
                status: 'failed',
                message: error.message || 'An error occurred during sign in',
            }
        }
    }

    /**
     * Post-Keycloak session bootstrap. Calls the same /login/validateuser
     * endpoint as the password-based signIn() above, but authenticated via
     * the Keycloak access token instead of an email/password body -- per the
     * backend team, this endpoint now resolves the HRMS user from the
     * token's email/preferred_username claim. Mirrors signIn()'s response
     * handling and localStorage population exactly, so the dashboard, menu
     * list and every existing session-dependent screen behave identically
     * regardless of which login path was used.
     */
    const signInWithKeycloak = async (accessToken: string): AuthResult => {
        try {
            const API_URL = import.meta.env.VITE_API_URL

            const response = await fetch(`${API_URL}/login/validateuser`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${accessToken}`,
                },
                body: JSON.stringify({ deviceType: 'WEB', serviceCode: 'HRMS' }),
                mode: 'cors',
            })

            const result = await response.json()

            if (result.statusCode !== 0) {
                throw new Error(result.errorDescription || 'Login failed')
            }

            localStorage.clear()

            localStorage.setItem('empCode', result.responseContent.empCode ?? '')
            localStorage.setItem('username', result.responseContent.username ?? '')
            localStorage.setItem(
                'maskedUsername',
                result.responseContent.maskedEmailId ??
                    result.responseContent.username ??
                    '',
            )
            localStorage.setItem('token', result.responseContent.token ?? '')
            localStorage.setItem(
                'employeePhotoRefNumber',
                result.responseContent.employeePhotoRefNumber ?? '',
            )
            localStorage.setItem(
                'firstName',
                `${result.responseContent.firstName ?? ''} ${result.responseContent.lastName ?? ''}`.trim(),
            )

            const userMenuList = result.responseContent.userMenuList
            localStorage.setItem('userMenuList', JSON.stringify(userMenuList))

            const userInnerMenuList = result.responseContent.userInnerMenuList
            localStorage.setItem('userInnerMenuList', JSON.stringify(userInnerMenuList))

            localStorage.setItem('mobileNumber', result.responseContent.mobileNumber ?? '')
            localStorage.setItem('department', result.responseContent.departmentMasterDTO?.code ?? '')
            localStorage.setItem('project', result.responseContent.projectMasterDTO?.code ?? '')
            localStorage.setItem('designation', result.responseContent.designationMasterDTO?.code ?? '')
            localStorage.setItem('reportingToEmailId', result.responseContent.reportingToEmailId ?? '')
            localStorage.setItem(
                'unmaskedReportingToEmailId',
                result.responseContent.unmaskedReportingToEmailId ?? '',
            )
            localStorage.setItem('designationname', result.responseContent.designationMasterDTO?.name ?? '')
            localStorage.setItem('projectname', result.responseContent.projectMasterDTO?.name ?? '')
            localStorage.setItem('gendername', result.responseContent.genderMasterDTO?.name ?? '')
            localStorage.setItem('gendercode', result.responseContent.genderMasterDTO?.code ?? '')

            const lastLogin = result.responseContent.loginCount
            localStorage.setItem('logincount', lastLogin)
            sessionStorage.setItem('logincount', lastLogin)

            const userData = result.responseContent

            handleSignIn(
                { accessToken: result.responseContent.token },
                result.responseContent,
            )

            const allUrlPaths: string[] = (userMenuList ?? []).flatMap((main: any) => {
                const urls: string[] = []

                if (main.urlPath) {
                    urls.push(main.urlPath)
                }

                if (Array.isArray(main.menuList)) {
                    main.menuList.forEach((sub: any) => {
                        if (sub.urlPath) {
                            urls.push(sub.urlPath)
                        }
                    })
                }

                return urls
            })

            const firstPath =
            allUrlPaths[0] || fallbackMenuPath(userMenuList) || '/home'

            if (!redirectToConsentIfPending(userData.pendingConsents)) {
                navigatorRef.current?.navigate(firstPath)

                if (userData.empCode) {
                    await registerFCMAfterLogin(userData.empCode)
                }
            }

            return {
                status: 'success',
                message: result.message || '',
            }
        } catch (error: any) {
            return {
                status: 'failed',
                message: error.message || 'An error occurred during sign in',
            }
        }
    }



      // 🔥 FCM Registration
   const registerFCMAfterLogin = async (empCode: string ) => {

  const VAPID_KEY = import.meta.env.VITE_FIREBASE_VAPID_KEY;
  const apiToken = import.meta.env.VITE_API_URL_TOKEN;

  try {
    console.log("🔵 Starting FCM registration...");

    if (!("serviceWorker" in navigator)) return;
    if (!messaging) return;

    const permission = await Notification.requestPermission();
    if (permission !== "granted") return;

    const registration = await navigator.serviceWorker.register(
      "/portal/firebase-messaging-sw.js",
      { scope: "/portal/" }
    );

    await navigator.serviceWorker.ready;

    console.log("✅ Service Worker Registered:", registration);

    const fcmToken = await getToken(messaging, {
      vapidKey: VAPID_KEY,
      serviceWorkerRegistration: registration,
    });

    console.log("🔥 FCM Token:", fcmToken);

    if (!fcmToken) return;

    // ✅ Correct axios syntax
    await axios.post(
      `${API_URL}/fcmtoken/register`,
      {
        empCode,
        token: fcmToken,
        deviceType: "WEB",
      },
      {
        headers: {
          Authorization: `Bearer ${apiToken}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      }
    );
    localStorage.setItem("fcmRegistered", "true");
    console.log("✅ FCM Registered Successfully");

  } catch (error) {
    console.error("❌ FCM registration error", error);
  }
};





    const signInotp = async (values: SignInotpCredential): AuthResult => {
        try {
            const API_URL = import.meta.env.VITE_API_URL

            const payload = {
  ...values,
  deviceType: "WEB", // always attach here
   serviceCode:"HRMS"
   
}
            // Perform the dynamic API call using fetch
            const response = await fetch(`${API_URL}/login/loginbyemailotp`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(payload),
                mode: 'cors',
            })

            // Parse the JSON result from the response
            const result = await response.json()

            // Check for success based on your API's internal statusCode
            if (result.statusCode !== 0) {
                // Throw error with the provided message from the API
                throw new Error(result.errorDescription || 'Login failed')
            }

            localStorage.clear() // Clears ALL localStorage data

            localStorage.setItem(
                'empCode',
                result.responseContent.empCode ?? '',
            )
            localStorage.setItem(
                'username',
                result.responseContent.username ?? '',
            )
            // Masked email for display only (profile dropdown). Falls back to the
            // full username if the backend didn't send a masked value.
            localStorage.setItem(
                'maskedUsername',
                result.responseContent.maskedEmailId ??
                    result.responseContent.username ??
                    '',
            )
            localStorage.setItem('token', result.responseContent.token ?? '')
            //  localStorage.setItem('firstName', result.responseContent.firstName ?? '' result.responseContent.lastName);

            localStorage.setItem(
                'firstName',
                `${result.responseContent.firstName ?? ''} ${result.responseContent.lastName ?? ''}`.trim(),
            )

            let userMenuList = result.responseContent.userMenuList
            localStorage.setItem(
                'employeePhotoRefNumber',
                result.responseContent.employeePhotoRefNumber ?? '',
            )

            localStorage.setItem('userMenuList', JSON.stringify(userMenuList))

let userInnerMenuList = result.responseContent.userInnerMenuList;

// Save to localStorage
localStorage.setItem('userInnerMenuList', JSON.stringify(userInnerMenuList));

            localStorage.setItem(
                'mobileNumber',
                result.responseContent.mobileNumber ?? '',
            )
            localStorage.setItem(
                'department',
                result.responseContent.departmentMasterDTO?.code ?? '',
            )
            localStorage.setItem(
                'project',
                result.responseContent.projectMasterDTO?.code ?? '',
            )
            localStorage.setItem(
                'designation',
                result.responseContent.designationMasterDTO?.code ?? '',
            )
            localStorage.setItem(
                'reportingToEmailId',
                result.responseContent.reportingToEmailId ?? '',
            )
            localStorage.setItem(
                'unmaskedReportingToEmailId',
                result.responseContent.unmaskedReportingToEmailId ?? '',
            )
            localStorage.setItem(
                'designationname',
                result.responseContent.designationMasterDTO?.name ?? '',
            )
            localStorage.setItem(
                'projectname',
                result.responseContent.projectMasterDTO?.name ?? '',
            )
            localStorage.setItem(
                'gendername',
                result.responseContent.genderMasterDTO?.name ?? '',
            )
            localStorage.setItem(
                'gendercode',
                result.responseContent.genderMasterDTO?.code ?? '',
            )
            const lastLogin = result.responseContent.loginCount

            const logincount = localStorage.getItem('logincount')
            // Assign '1' if lastLogin is null, undefined, or an empty string
            localStorage.setItem('logincount', lastLogin)
            if (logincount === 'null' ) {
            } else {
                // Handle sign-in logic if the API call was successful
                handleSignIn(
                    { accessToken: result.responseContent.token },
                    result.responseContent,
                )
            }
              const allUrlPaths: string[] = userMenuList.flatMap((main: any) => {
            const urls: string[] = [];

            if (main.urlPath) {
                urls.push(main.urlPath);
            }

            if (Array.isArray(main.menuList)) {
                main.menuList.forEach((sub: any) => {
                    if (sub.urlPath) {
                        urls.push(sub.urlPath);
                    }
                });
            }

            return urls;
        });

        const firstPath =
            allUrlPaths[0] || fallbackMenuPath(userMenuList) || '/home';
const logincount1 = localStorage.getItem('logincount')
        // 🔥 Handle OTP first login
        if (logincount1 === 'null') {
            redirect();
            location.reload();
        } else if (redirectToConsentIfPending(result.responseContent.pendingConsents)) {
            // Mandatory consent(s) outstanding -- routed to /consent instead.
        } else {
            navigatorRef.current?.navigate(firstPath);
 const userData = result.responseContent
             if (userData.empCode) {
            await registerFCMAfterLogin(userData.empCode);
        }

        }

            return {
                status: 'success',
                message: result.message || '',
            }
        } catch (error: any) {
            return {
                status: 'failed',
                message: error.message || 'An error occurred during sign in',
            }
        }
    }

  const signIn1 = async (values: SignInQrcodeCredential): AuthResult => {

    const params = new URLSearchParams(window.location.search);
    const redirectUrl = params.get(REDIRECT_URL_KEY);

    const username = localStorage.getItem('username');
    const empCode = localStorage.getItem('empCode');
    const logincount = localStorage.getItem('logincount');

    const staticUser = {
        email: values.emailId,
        name: values.usrname,
    };

    const staticToken: SignInQrcodeCredential = {
        emailId: values.emailId,
        userdata: values.userdata,
        empCode: values.empCode,
        usrname: values.usrname,
        user:values.user
    };




const result: any = values.user;


localStorage.setItem('empCode', result.empCode);
localStorage.setItem(
    'userMenuList',
    JSON.stringify(result.userMenuList ?? [])
  );

  localStorage.setItem(
    'userInnerMenuList',
    JSON.stringify(result.userInnerMenuList ?? [])
  );

  // ===== Save User Info =====
  localStorage.setItem('empCode', result.empCode ?? '');
  localStorage.setItem('username', result.username ?? '');
  // Masked email for display only (profile dropdown).
  localStorage.setItem(
    'maskedUsername',
    result.maskedEmailId ?? result.username ?? ''
  );
  localStorage.setItem('token', result.token ?? '');

  localStorage.setItem(
    'firstName',
    `${result.firstName ?? ''} ${result.lastName ?? ''}`.trim()
  );

  localStorage.setItem('mobileNumber', result.mobileNumber ?? '');
  localStorage.setItem('department', result.departmentMasterDTO?.code ?? '');
  localStorage.setItem('project', result.projectMasterDTO?.code ?? '');
  localStorage.setItem('designation', result.designationMasterDTO?.code ?? '');
  localStorage.setItem('reportingToEmailId', result.reportingToEmailId ?? '');
  localStorage.setItem('unmaskedReportingToEmailId', result.unmaskedReportingToEmailId ?? '');
  localStorage.setItem('designationname', result.designationMasterDTO?.name ?? '');
  localStorage.setItem('projectname', result.projectMasterDTO?.name ?? '');
  localStorage.setItem('gendername', result.genderMasterDTO?.name ?? '');
  localStorage.setItem('gendercode', result.genderMasterDTO?.code ?? '');
  localStorage.setItem('employeePhotoRefNumber', result.employeePhotoRefNumber ?? '');

console.log(result); 

// Save session
localStorage.setItem(
  'sessionUser',
  JSON.stringify({
    state: {
      session: { signedIn: true },
      user: result,
    },
  })
);


    //const usermenulist = values.userdata ?? [];
let usermenulist: any[] = [];

        if (typeof values.userdata === 'string') {
            try {
                usermenulist = JSON.parse(values.userdata);
            } catch (error) {
                console.error('Invalid userdata JSON:', error);
                usermenulist = [];
            }
        } else if (Array.isArray(values.userdata)) {
            usermenulist = values.userdata;
        }

    const allUrlPaths: string[] = usermenulist.flatMap((main: any) => {
        const urls: string[] = [];

        if (main.urlPath) urls.push(main.urlPath);

        if (Array.isArray(main.menuList)) {
            main.menuList.forEach((sub: any) => {
                if (sub.urlPath) urls.push(sub.urlPath);
            });
        }

        return urls;
    });

    const firstPath =
            allUrlPaths[0] || fallbackMenuPath(usermenulist) || '/home';

    const consentPending = redirectToConsentIfPending(result.pendingConsents)

    if (!consentPending) {
        navigatorRef.current?.navigate(firstPath);
    }

console.log(firstPath);




 ///navigatorRef.current?.navigate(firstPath);
handleSignIn({ accessToken: staticToken.emailId }, staticUser);
//     console.log(values.empCode); 



// if ( values.empCode) {
//              await registerFCMAfterLogin( values.empCode);
//         }
    // if (!logincount) {
    //     redirect();
    //     location.reload();
    // } else {
       // navigatorRef.current?.navigate(firstPath);

        if ( values.empCode) {
            await registerFCMAfterLogin( values.empCode);
        }
  //  }



//     if (logincount1 === 'null') {
//             redirect(); 
//             location.reload(); 
//         } else {
//             navigatorRef.current?.navigate(firstPath);
//  const userData = result.responseContent
//              if (empCode) {
//            await registerFCMAfterLogin(empCode);
//         }

//         }

    return {
        status: 'success',
        message: 'Login successful',
    };
};

    const signotp = async (values: SignotpCredential): AuthResult => {
        try {
            const API_URL = import.meta.env.VITE_API_URL
            // Perform the dynamic API call using fetch
            //const response = await fetch(`${API_URL}/otp/verify`, {
            const response = await fetch(
                `${API_URL}/empregister/verifyempregotp`,
                {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify(values),

                    mode: 'cors',
                },
            )
            // Clears ALL localStorage data

            // Parse the JSON result from the response
            const result = await response.json()

            // Check for success based on your API's internal statusCode
            if (result.statusCode !== 0) {
                // Throw error with the provided message from the API
                throw new Error(
                    result.errorDescription || 'OTP validation failed',
                )
            }
            localStorage.clear()
            const staticToken = 'your_static_token_here'
            const staticUser = {
                email: 'values',
                name: 'Static User',
            }
            localStorage.setItem('username', values.emailId)

            console.log(result)

            if (result && result.responseContent != null) {
                localStorage.setItem('RegCode', result.responseContent)
            } else {
                localStorage.setItem('RegCode', '0')
            }


             if (result && result.responseContent != null) {
                sessionStorage.setItem('RegCode', result.responseContent)
            } else {
                sessionStorage.setItem('RegCode', '0')
            }

            // // Handle sign-in with static values
            handleSignIn({ accessToken: staticToken }, staticUser)

            // Redirect after sign-in
            redirect()
            location.reload()
            /// redirect();

            return {
                status: 'success',
                message: result.message || 'OTP verified successfully',
            }
        } catch (error: any) {
            return {
                status: 'failed',
                message: error.message || 'Invalid OTP. Please try again',
            }
        }
    }

    const signUp = async (values: SignUpCredential): AuthResult => {
        try {
            const resp = await apiSignUp(values)
            if (resp) {
                // handleSignIn({ accessToken: resp.token }, resp.user)
                // redirect()
                return {
                    status: 'success',
                    message: '',
                }
            }
            return {
                status: 'failed',
                message: 'Unable to sign up',
            }
            // eslint-disable-next-line  @typescript-eslint/no-explicit-any
        } catch (errors: any) {
            return {
                status: 'failed',
                message: errors?.response?.data?.message || errors.toString(),
            }
        }
    }

    const signOut = async () => {
        try {
            await apiSignOut()
        } finally {
            const keepEnv = localStorage.getItem('env')
            localStorage.clear()
            if (keepEnv) localStorage.setItem('env', keepEnv)
            sessionStorage.removeItem(CONSENT_REQUIRED_KEY)
            sessionStorage.removeItem(CONSENT_ACCEPTED_COUNT_KEY)
            sessionStorage.removeItem(CONSENT_TOTAL_KEY)

            // SSO disabled: plain HRMS logout with a full reload, as before SSO.
            if (!isKeycloakEnabled()) {
                window.location.replace(
                    `/portal${appConfig.unAuthenticatedEntryPath}`,
                )
                return
            }

            // Bypass ProtectedRoute so it cannot start a new login during logout.
            setToken('')
            setUser({})
            setSessionSignedIn(false)
            navigatorRef.current?.navigate('/auth/logout', { replace: true })
        }
    }
    const oAuthSignIn = (
        callback: (payload: OauthSignInCallbackPayload) => void,
    ) => {
        callback({
            onSignIn: handleSignIn,
            redirect,
        })
    }

    const empcodevaild = async (values: empcodevaild): AuthResult => {
        try {
            const officialEmailId = localStorage.getItem('username')
            if (!officialEmailId) {
                throw new Error('Email not found in localStorage')
            }

            const API_URL = import.meta.env.VITE_API_URL
            if (!API_URL) {
                throw new Error(
                    'API URL is not defined in environment variables',
                )
            }

            const response = await fetch(
                `${API_URL}/empregister/getempbyemail`,
                {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ officialEmailId }),
                },
            )

            if (!response.ok) {
                throw new Error(
                    `HTTP Error: ${response.status} - ${response.statusText}`,
                )
            }

            const result = await response.json()

            if (result.statusCode !== 0) {
                throw new Error(result.message || 'Login failed')
            }

            const emp = result.responseContent
            if (!Array.isArray(emp) || emp.length === 0) {
                throw new Error('Employee data not found')
            }

            const empCode = emp[0].code || '0'

            // console.log(empCode);

            localStorage.setItem('RegCode', empCode)

            return {
                status: 'success',
                message: 'Login successful',
                //  data: result.data,
                //  code, // Including the extracted code
            }
        } catch (error: any) {
            return {
                status: 'failed',
                message: error.message || 'Invalid OTP. Please try again',
            }
        }
    }

        const changepasswordsumbit = async (values: changepasswordsumbit): AuthResult => {
  try {
    const API_URL = import.meta.env.VITE_API_URL;
    const token = import.meta.env.VITE_API_URL_TOKEN;

    const response = await fetch(`${API_URL}/forgotpassword/submit`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      body: JSON.stringify(values),
      mode: 'cors',
      credentials: 'include',
    });

    const result = await response.json();

    if (result.statusCode !== 0) {
      throw new Error(result.errorDescription || 'Login failed');
    }

    sessionStorage.setItem("authToken", result.responseContent.token);
    sessionStorage.setItem("userEmail", result.responseContent.emailId);

    handleSignIn(
      { accessToken: result.responseContent.token },
      {
        email: result.responseContent.emailId,
       
      }
    );

    return {
      status: 'success',
      message: result.message || '',
    };
  } catch (error: any) {
    return {
      status: 'failed',
      message: error.message || 'An error occurred during sign in',
    };
  }
};

    // Bootstraps the existing HRMS session from the already-established
    // Keycloak session. Runs once on mount; if an HRMS session already
    // exists (e.g. page refresh), `authenticated` is already true from
    // localStorage/cookie rehydration, so this is a no-op on refresh --
    // satisfying "don't unnecessarily show the login page again".
    useEffect(() => {
        if (authenticated) {
            setBootstrappingKeycloakSession(false)
            return
        }

        if (isKeycloakEnabled() && isKeycloakAuthenticated()) {
            const accessToken = getKeycloakToken()
            if (accessToken) {
                signInWithKeycloak(accessToken).finally(() => {
                    setBootstrappingKeycloakSession(false)
                })
                return
            }
        }

        setBootstrappingKeycloakSession(false)
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return (
        <AuthContext.Provider
            value={{
                authenticated,
                user,
                signIn,
                signInWithKeycloak,
                signInotp,
                signIn1,
                signUp,
                signOut,
                oAuthSignIn,
                signotp,
                empcodevaild,
                changepasswordsumbit
            }}
        >
            {bootstrappingKeycloakSession ? <LoadingScreen /> : children}
            <IsolatedNavigator ref={navigatorRef} />
        </AuthContext.Provider>
    )
}

IsolatedNavigator.displayName = 'IsolatedNavigator'

export default AuthProvider
